import React from 'react';
import { IconProps } from './types';

const FlagIcon: React.FC<IconProps> = props => {
  const { height = '16', width = '16' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <mask id="mask0_2412_44557" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2412_44557)">
        <path
          d="M4.66683 8.66667V14C4.66683 14.1889 4.60294 14.3472 4.47516 14.475C4.34738 14.6028 4.18905 14.6667 4.00016 14.6667C3.81127 14.6667 3.65294 14.6028 3.52516 14.475C3.39738 14.3472 3.3335 14.1889 3.3335 14V2.66667C3.3335 2.47778 3.39738 2.31944 3.52516 2.19167C3.65294 2.06389 3.81127 2 4.00016 2H13.0168C13.1391 2 13.2474 2.02778 13.3418 2.08333C13.4363 2.13889 13.5113 2.21111 13.5668 2.3C13.6224 2.38889 13.6585 2.48611 13.6752 2.59167C13.6918 2.69722 13.6779 2.80556 13.6335 2.91667L12.6668 5.33333L13.6335 7.75C13.6779 7.86111 13.6918 7.96944 13.6752 8.075C13.6585 8.18056 13.6224 8.27778 13.5668 8.36667C13.5113 8.45556 13.4363 8.52778 13.3418 8.58333C13.2474 8.63889 13.1391 8.66667 13.0168 8.66667H4.66683Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default FlagIcon;
